import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPanoramaView: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"panorama-view"} maskId="square-filled-radius-0-stroke-1-IconPanoramaView"><path d="M1.66059 4.02653L1 3.80249V20.2012L1.66289 19.9728C8.76061 17.5271 15.2394 17.5271 22.3371 19.9728L23 20.2012V3.80249L22.3394 4.02653C15.2008 6.44761 8.79922 6.44761 1.66059 4.02653Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPanoramaView;
